if (!customElements.get('direct-send-addon')) {
  customElements.define(
    'direct-send-addon',
    class DirectSendAddon extends HTMLElement {
      connectedCallback() {
        this.mode =
          this.dataset.addonMode || 'direct-send';

        this.toggle = this.querySelector(
          '[data-direct-send-toggle], [data-simple-addon-toggle]'
        );

        this.fieldsContainer = this.querySelector(
          '[data-direct-send-fields]'
        );

        this.fields = Array.from(
          this.querySelectorAll(
            '[data-direct-send-property]'
          )
        );

        this.form = this.closest('form');

        this.variantInput =
          this.form?.querySelector('[name="id"]');

        if (this.mode === 'direct-send') {
          this.loadVariants();
          this.hideOriginalVariantPicker();
        }

        if (!this.toggle) return;

        this.toggle.addEventListener('change', () => {
          this.updateVisibility();
        });

        this.fields.forEach((field) => {
          field.addEventListener('input', () => {
            field.setCustomValidity('');
            field.classList.remove('invalid');
          });
        });

        this.updateVisibility();
      }

      get isSelected() {
        return Boolean(
          this.toggle && this.toggle.checked
        );
      }

      loadVariants() {
        const variantData = this.querySelector(
          '[data-direct-send-variants]'
        );

        if (!variantData) return;

        try {
          this.variants = JSON.parse(
            variantData.textContent
          );
        } catch (error) {
          console.error(
            'Varianten konden niet worden gelezen.',
            error
          );

          this.variants = [];
        }

        this.selfVariant = this.variants.find(
          (variant) =>
            variant.options.includes(
              'Ik schrijf de kaart zelf'
            )
        );

        this.directVariant = this.variants.find(
          (variant) =>
            variant.options.includes(
              'Stuur direct naar de ontvanger'
            )
        );

        if (!this.selfVariant || !this.directVariant) {
          console.error(
            'De varianten voor rechtstreeks versturen zijn niet gevonden.'
          );

          this.toggle.disabled = true;
        }
      }

      hideOriginalVariantPicker() {
        const sectionId = this.dataset.sectionId;

        document
          .querySelectorAll('variant-selects')
          .forEach((picker) => {
            if (
              !sectionId ||
              picker.dataset.section === sectionId
            ) {
              picker.hidden = true;
            }
          });
      }

      updateVisibility() {
        if (
          this.mode === 'direct-send' &&
          this.fieldsContainer
        ) {
          this.fieldsContainer.hidden =
            !this.isSelected;

          this.fields.forEach((field) => {
            field.disabled = !this.isSelected;

            if (!this.isSelected) {
              field.setCustomValidity('');
              field.classList.remove('invalid');
            }
          });

          this.selectCorrectVariant();
        }
      }

      selectCorrectVariant() {
        if (
          this.mode !== 'direct-send' ||
          !this.variantInput
        ) {
          return;
        }

        const selectedVariant = this.isSelected
          ? this.directVariant
          : this.selfVariant;

        if (!selectedVariant) return;

        this.variantInput.value =
          String(selectedVariant.id);

        this.variantInput.disabled = false;

        this.variantInput.dispatchEvent(
          new Event('change', {
            bubbles: true
          })
        );
      }

      validate(quantity) {
        if (!this.isSelected) return true;

        if (this.mode === 'simple') {
          return true;
        }

        if (Number(quantity) !== 1) {
          const quantityInput =
            this.form?.querySelector(
              '[name="quantity"]'
            );

          if (quantityInput) {
            quantityInput.setCustomValidity(
              'Kies aantal 1 wanneer je deze kaart rechtstreeks laat versturen. Voeg meerdere kaarten afzonderlijk toe.'
            );

            quantityInput.reportValidity();
          }

          return false;
        }

        let firstInvalid = null;

        this.fields.forEach((field) => {
          const valid = field.value.trim() !== '';

          field.setCustomValidity(
            valid ? '' : 'Vul dit veld in.'
          );

          field.classList.toggle(
            'invalid',
            !valid
          );

          if (!valid && !firstInvalid) {
            firstInvalid = field;
          }
        });

        if (firstInvalid) {
          firstInvalid.reportValidity();
          firstInvalid.focus();
          return false;
        }

        return true;
      }

      getFormProperties(formData) {
        const properties = {};

        for (const [name, value] of formData.entries()) {
          const match = name.match(
            /^properties\[(.+)\]$/
          );

          if (match && value !== '') {
            properties[match[1]] = value;
          }
        }

        return properties;
      }

      createPairId(prefix) {
        return window.crypto?.randomUUID
          ? window.crypto.randomUUID()
          : `${prefix}-${Date.now()}-${Math.random()
              .toString(16)
              .slice(2)}`;
      }

      buildSimpleAddonItems(formData) {
        const quantity = Number(
          formData.get('quantity') || 1
        );

        const pairId =
          this.createPairId('addon');

        const cardProperties =
          this.getFormProperties(formData);

        cardProperties._addon_pair = pairId;

        return [
          {
            id: Number(formData.get('id')),
            quantity: quantity,
            properties: cardProperties
          },
          {
            id: Number(
              this.dataset.addonVariantId
            ),
            quantity: quantity,
            properties: {
              _addon_pair: pairId,
              _bijbehorend_product:
                this.dataset.productTitle
            }
          }
        ];
      }

      buildDirectSendItems(formData) {
        const quantity = Number(
          formData.get('quantity') || 1
        );

        this.selectCorrectVariant();

        const selectedCardVariant =
          this.isSelected
            ? this.directVariant
            : this.selfVariant;

        if (!selectedCardVariant) {
          return null;
        }

        const pairId =
          this.createPairId('direct');

        const cardProperties =
          this.getFormProperties(formData);

        cardProperties._direct_send_pair = pairId;

        const serviceProperties = {
          'Bijbehorende kaart':
            this.dataset.productTitle,

          _direct_send_pair: pairId
        };

        this.fields.forEach((field) => {
          serviceProperties[
            field.dataset.directSendProperty
          ] = field.value.trim();
        });

        return [
          {
            id: Number(selectedCardVariant.id),
            quantity: 1,
            properties: cardProperties
          },
          {
            id: Number(
              this.dataset.serviceVariantId
            ),
            quantity: 1,
            properties: serviceProperties
          }
        ];
      }

      buildCartItems(formData) {
        const quantity = Number(
          formData.get('quantity') || 1
        );

        if (!this.validate(quantity)) {
          return null;
        }

        if (this.mode === 'simple') {
          return this.buildSimpleAddonItems(
            formData
          );
        }

        return this.buildDirectSendItems(formData);
      }
    }
  );
}